"use strict";

define('uikit/extra/input.change.tracker',['underscore', 'jquery'], function (_, $) {
  function InputChangeTracker(input) {
    this.$input = $(input);
    this.input = this.$input.get(0);
    this.startIndex = this.inputSelectionStart();
    this.startLength = this.inputValue().length;
  }
  ;
  _.extend(InputChangeTracker.prototype, {
    inputSelectionStart: function inputSelectionStart() {
      return this.input.selectionStart;
    },
    value: function value() {
      var value = this.inputValue(),
        startIndex = this.startIndex,
        endIndex = startIndex + value.length - this.startLength;
      return startIndex > -1 ? value.slice(startIndex, endIndex) : '';
    },
    inputValue: function inputValue() {
      return this.$input.val();
    },
    leftValue: function leftValue(offset) {
      offset = offset || 0;
      return this.inputValue().slice(0, this.startIndex - offset);
    },
    rightValue: function rightValue(offset) {
      var currentvalue = this.value();
      offset = offset || 0;
      return this.inputValue().slice(this.startIndex + currentvalue.length - offset);
    }
  });
  return InputChangeTracker;
});

